import React from "react";
import DriverAddOrUpdateContent from "../content/driverAddOrUpdateContent";
import Layout from "../layout/Layout";

const DriverAddOrUpdate = () => {
  return (
    <Layout>
      <DriverAddOrUpdateContent />
    </Layout>
  );
};

export default DriverAddOrUpdate;
